import classNames from 'classnames';
import React, { createContext, useContext } from 'react';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

// By using a context, anything deeper in a table that wants to use this value, which is for column definitions, can use the most recent parent table context.
const TableContext = createContext<[string | undefined, number | undefined]>([undefined, undefined]);

export interface IStyledTableProps {
  columnCount?: number;
  gridTemplateColumn?: string;
  className?: string;
}
export const StyledTable: FCWithChildren<IStyledTableProps> = ({
  children,
  gridTemplateColumn,
  columnCount,
  className,
}) => {
  return (
    <TableContext.Provider value={[gridTemplateColumn, columnCount]}>
      <div className={`grid ${className}`}>{children}</div>
    </TableContext.Provider>
  );
};

export const StyledTableHeader: FCWithChildren = ({ children }) => (
  <div className={'grid bg-gray-100 font-semibold text-gray-600'}>{children}</div>
);

export const StyledTableContent: FCWithChildren<{ className?: string }> = ({ children, className }) => (
  <div className={classNames(`grid`, className)}>{children}</div>
);

export const StyledTableRowColumn: FCWithChildren<{ className?: string }> = ({ children, className }) => (
  <div className={classNames(`p-4 text-base`, className)}>{children}</div>
);

export const StyledTableNumberColumn: FCWithChildren<{ className?: string }> = ({ children, className }) => (
  <div className={classNames(`self-start justify-self-center p-4`, className)}>{children}</div>
);

export const StyledTableRow: React.FC<{ className?: string; onClick?: () => void; children?: React.ReactNode }> = ({
  className,
  children,
  onClick,
}) => {
  const [gridTemplateColumns, columnCount = 0] = useContext(TableContext);
  if (columnCount > 0 || typeof gridTemplateColumns === 'undefined') {
    return (
      <div
        className={classNames(`grid border-t border-solid border-gray-200`, className)}
        style={{ gridTemplateColumns: `36px 420px repeat(${columnCount - 1}, 1fr) 36px` }}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }
  return (
    <div
      className={classNames(`grid border-t border-solid border-gray-200`, className)}
      style={{ gridTemplateColumns }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
